<template>
    <v-dialog
        v-model="dialog"
        persistent 
        scrollable
        max-width="500px"
        transition="dialog-transition">
        <template v-slot:activator="{ on }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                    <v-icon small class="mr-2" v-on="{...tooltip, ...on}"
                    @click="getDataEstructura()">mdi-pencil</v-icon>
                </template>
                <span>Modificar</span>
            </v-tooltip>
        </template>
         <v-card :loading="loading">
             <v-card-title class="pa-0">
               <ModalTitle titulo="Modificar Estructura Legal" @cancelar="cancelar"/>
            </v-card-title>  
            <v-divider />
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-text-field label="Nombre"
                        v-model="estructura.nombre"
                        :error-messages="nameErrors"
                        @input="$v.estructura.nombre.$touch()"
                        @blur="$v.estructura.nombre.$touch()"
                        required>
                        </v-text-field>
                    </v-col>
                    <!-- <v-col cols="12">
                        <v-textarea label="Descripción"
                        v-model="estructura.descripcion"
                        counter="100"
                        hint="Campo Opcional"
                        outlined
                        shaped>
                        </v-textarea>
                    </v-col> -->
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text :disabled="loading" color="error" @click="cancelar">Cancelar</v-btn>
                <v-btn text :loading="loading" color="#0B3F67" @click="modificarEstructura">Modificar</v-btn>
            </v-card-actions>
         </v-card>      
    </v-dialog>    
</template>

<script>
import axios from "@/axios.js";
import {required, email} from "vuelidate/lib/validators";
import ModalTitle from '@/components/utils/ModalTitleComponent'
export default {
    props: [
        'idEstructura'
    ],
    components: {
      ModalTitle
    },
    created() {
        axios.defaults.headers.common['Authorization'] = "Bearer " + this.$store.getters.token;
    },     
    computed: {
        nameErrors () {
            const errors = []
            if (!this.$v.estructura.nombre.$dirty) return errors            
            !this.$v.estructura.nombre.required && errors.push('El nombre es requerido.')
            return errors
        },
    },
    data: () => ({
        dialog: false,
        loading: false,
        estructura: {
            nombre: '',
            descripcion: '',    
        },
    }),
    validations: {
        estructura: {  
            nombre: {
                required
            },
        }
    },
    methods:{
        getDataEstructura() {
            this.loading = true;
            axios.get("/estructura/getDataEstructura/"+this.idEstructura).then(response => {
                this.estructura = response.data.estructura;
                this.loading = false;
            }).catch(error => {
              if (error.request && error.request.status === 401) {
                this.$store.commit('showSessionDialog', true);
              } else {
                console.log(error);
                this.loading = false;
              }
            })
        },
        modificarEstructura() {
            this.$v.$touch();
            if(!this.$v.$invalid) { 
                this.loading = true;
                axios.put("/estructura/modificarEstructura/"+this.idEstructura, this.estructura).then(response => {
                    this.cancelar();
                    this.$store.dispatch('noti',{mensaje: 'Estructura legal modificada', color:'success'});
                    this.$emit('reloadEdit');
                }).catch(error => {
                  if (error.request && error.request.status === 401) {
                    this.$store.commit('showSessionDialog', true);
                  } else {
                    console.log(error);
                    this.$store.dispatch('noti', {mensaje: 'Ocurrió un error no se modificó la estructura legal', color:'error'});
                    this.cancelar();
                  }
                })
            }
        },
        cancelar() {
            this.estructura = {};
            this.dialog = false;
            this.loading = false;            
            this.$v.estructura.$reset();
        },
    },
}
</script>